import {
  REIMBURSEMENTTYPE_LOADING,
  GET_REIMBURSEMENTTYPE,
  GET_REIMBURSEMENTTYPE_SUCCESS,
  GET_REIMBURSEMENTTYPE_FAIL,
  ADD_REIMBURSEMENTTYPE_SUCCESS,
  ADD_REIMBURSEMENTTYPE_FAIL,
  DELETE_REIMBURSEMENTTYPE_SUCCESS,
  DELETE_REIMBURSEMENTTYPE_FAIL,
  UPDATE_REIMBURSEMENTTYPE_SUCCESS,
  UPDATE_REIMBURSEMENTTYPE_FAIL,
  REIMBURSEMENTTYPE_RESET
} from "./actionType";

const INIT_STATE = {
  reimbursementTypes: [],
  error: {},
};

const ReimbursementType = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_REIMBURSEMENTTYPE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_REIMBURSEMENTTYPE:
          return {
            ...state,
            reimbursementTypes: action.payload.data,
            isReimbursementTypeCreated: false,
            isReimbursementTypeSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_REIMBURSEMENTTYPE_FAIL:
      switch (action.payload.actionType) {
        case GET_REIMBURSEMENTTYPE_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isReimbursementTypeCreated: false,
            isReimbursementTypeSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_REIMBURSEMENTTYPE: {
      return {
        ...state,
        isReimbursementTypeCreated: false,
        loading: true,
      };
    }

    case REIMBURSEMENTTYPE_LOADING: {
      return {
        ...state,
        isReimbursementTypeCreated: false,
        loading: true,
      };
    }

    case ADD_REIMBURSEMENTTYPE_SUCCESS:
      return {
        ...state,
        isReimbursementTypeCreated: true,
        loading: false,
        reimbursementTypes: [action.payload.data, ...state.reimbursementTypes],
      };

    case ADD_REIMBURSEMENTTYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_REIMBURSEMENTTYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        isReimbursementTypeCreated: true,
        reimbursementTypes: state.reimbursementTypes.filter(
          reimbursementType => reimbursementType.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_REIMBURSEMENTTYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_REIMBURSEMENTTYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        isReimbursementTypeCreated: true,
        reimbursementTypes: state.reimbursementTypes.map(reimbursementType =>
          reimbursementType.id.toString() === action.payload.data.id.toString() ? { ...reimbursementType, ...action.payload.data } : reimbursementType
        ),
      };

    case UPDATE_REIMBURSEMENTTYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case REIMBURSEMENTTYPE_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default ReimbursementType;